import React from "react";
// import logo1 from "../assets/img/Logo1.png";

const PageLoader = () => {
  return (
    <div className="w-full min-h-[50vh] flex flex-col items-center justify-center gap-6  backdrop-blur-md animate-fadeIn">
      {/* <img
        src={logo1}
        alt="Loading..."
        className="w-20 h-20 animate-logoPulse"
      /> */}
      <p className="text-lg text-gray-700 font-medium animate-pulse">Loading...</p>
    </div>
  );
};

export default PageLoader;
